module.exports = __webpack_public_path__ + "static/media/Aeravision.31c4c0fb.jpeg";